//import 'bootstrap';
// Import just what we need

//import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

// Custom scripts
import setScrollPadding from "./frontend/scrollPadding";
import servicesOverviewSlider from "./frontend/slider";
import menuInit from "./frontend/menu";
import setQuotationMarkTop from "./frontend/setQuotationMarkMobile";
import removeDropdownOnMobile from './frontend/bigMenuOnMobile';
import testimonialSlider from "./frontend/testimonialSlider";
import contentBarControls from "./frontend/contentBarControls";
import sectionJumperFindActive from "./frontend/checkIfSectionActive";
import contactBackButtonControl from './frontend/contactBackButtonControl';
import formExtra from './frontend/formExtra';
import scrollTop from './frontend/scrollTop';
import accordionScrollTop from './frontend/accordionScrollTop';
import closeSectionRegisterIfScrollToBlock from "./frontend/closeSectionRegisterIfScrollToBlock";
import footerConsentmanagerTrigger from "./frontend/consentmanager";
let timeoutId = null;
const documentHeight = () => {
    clearTimeout(timeoutId); // avoid execution of previous timeouts
    timeoutId = setTimeout(() => {
        const doc = document.documentElement;
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }, 200);
};

document.onreadystatechange = () => {
    if (document.readyState === 'complete') {



    }
}
window.addEventListener('load', () =>{
    setScrollPadding();
    documentHeight();

    testimonialSlider();
    servicesOverviewSlider();
    formExtra();
    scrollTop();
    closeSectionRegisterIfScrollToBlock();
    footerConsentmanagerTrigger();
    sectionJumperFindActive();
    setQuotationMarkTop();
    accordionScrollTop();
    contentBarControls();
    menuInit();
    removeDropdownOnMobile();
    contactBackButtonControl();
});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    documentHeight();
    if(currentWidth === window.innerWidth) return;
    setScrollPadding();
    servicesOverviewSlider();
    menuInit();
    setQuotationMarkTop();
    removeDropdownOnMobile();
    testimonialSlider();
    sectionJumperFindActive();

    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', function () {

    setScrollPadding();
    servicesOverviewSlider();
    menuInit();
    setQuotationMarkTop();
    removeDropdownOnMobile();
    testimonialSlider();
    sectionJumperFindActive();
});
